import React from 'react';
import VeloContent from '../components/VeloContent';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem 1rem;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const BackButton = styled.button`
  background: #8a2be2;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  cursor: pointer;
  margin-bottom: 1rem;
  
  &:hover {
    background: #6a1b9a;
  }
`;

const VeloPage = () => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <PageContainer>
      <Header>
        <BackButton onClick={handleBack}>
          ← Volver
        </BackButton>
        <h1 style={{ color: '#8a2be2', margin: 0 }}>
          Tertulia Feminista Les Comadres
        </h1>
      </Header>
      
      <VeloContent />
    </PageContainer>
  );
};

export default VeloPage; 